import { gql } from '@apollo/client';
import { GRAPHQL_CLIENT_NAMES } from 'lib/types';
import {
    DigitalWalkInSlots,
    DigitalWalkInTimeSlotsArguments,
} from '@bondvet/types/digitalWalkIns/index';
import useBookingQuery from './useBookingQuery';
import { DigitalWalkInQuery } from '../lib/types';

const GET_DIGITAL_WALKIN_AVAILABILITY = gql`
    query GetDigitalWalkInAvailability($locationId: InternalId!) {
        digitalWalkInTimeSlots(locationId: $locationId) {
            available
            timezone
            maxAvailableTimeSlots
            timeSlots
        }
    }
`;

export interface UseDigitalWalkInAvailabilityResult {
    data?: DigitalWalkInSlots;
    loading: boolean;
    error?: Error;
}

/**
 * Custom hook to fetch digital walk-in availability for a location.
 * @param locationId - Internal ID of the clinic location
 * @returns {UseDigitalWalkInAvailabilityResult} - Digital walk-in availability data
 */
export const useDigitalWalkInAvailability = (
    locationId: string,
): UseDigitalWalkInAvailabilityResult => {
    const { data, loading, error } = useBookingQuery<
        DigitalWalkInQuery,
        DigitalWalkInTimeSlotsArguments
    >(GET_DIGITAL_WALKIN_AVAILABILITY, {
        fetchPolicy: 'no-cache',
        context: {
            clientName: GRAPHQL_CLIENT_NAMES.booking,
        },
        variables: { locationId },
        skip: !locationId,
    });

    return {
        data: data?.digitalWalkInTimeSlots,
        loading,
        error,
    };
};
